import { useQuery } from "react-query";
import { GET_CRISIS_PLAN, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getCrisisPlan } from "api/clinicalManagement";
import extractRecords from "../utils/extractRecords";

export type CrisisPlanRecord = Record<string, unknown>;

const useGetCrisisPlan = (clientId: number | null) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_CRISIS_PLAN, clientId],
    () => getCrisisPlan(clientId),
    {
      staleTime: STALE_TIME_5_MINUTES,
      enabled: Boolean(clientId),
      refetchOnWindowFocus: false,
    }
  );

  const records = extractRecords<CrisisPlanRecord>(data);
  const crisisPlan = records.length > 0 ? records[0] : null;

  return {
    crisisPlan,
    crisisPlanLoading: isLoading,
    refetchCrisisPlan: refetch,
    ...rest,
  };
};

export default useGetCrisisPlan;
